<template>
  <div class="container-fluid">
    <div class="row w-100 px-0">
      <div class="col-12 w-100 p-0 d-flex align-items-center justify-content-center">
        <!-- Card Flotante -->

        <div v-if="currentTab === 0 && statusItems.length > 0">
          <div v-if="!isCardMinimized" class="states">
            <b-col cols="12" class="mb-md-0 mb-2">
              <!-- Contenido del card -->
              <ul>
                <li v-for="(item, index) in statusItems" :key="index">
                  <div
                    :style="{
                      backgroundColor: item.color,
                      borderRadius: '50%',
                      height: '18px',
                      width: '18px',
                      marginRight: '5px',
                    }"
                  ></div>
                  <span>{{ $t(`service_orders.${item.status}`) }}</span>
                </li>
              </ul>
              <!-- Botón para minimizar -->
              <button @click="toggleCardMinimize" class="minimize-button">
                <b-icon-dash-circle-fill scale="1" />
              </button>
            </b-col>
          </div>
          <div v-else class="minimized-states-icon">
            <!-- Icono para expandir -->
            <button @click="toggleCardMinimize" class="plus-button">
              <b-icon-question scale="2" />
            </button>
          </div>
        </div>

        <div class="export-button" v-if="currentTab === 0">
          <button v-if="currentTab === 0" @click="getGeoJson" class="plus-button">
            <b-icon-download scale="2" />
          </button>
        </div>

        <!-- Tabs -->
        <b-tabs pills align="center" fill v-model="currentTab">
          <b-tab title="Mapa">
            <div class="flex-container">
              <div class="map-container">
                <MapComponent
                  :filters="filters"
                  @showBookletModal="showBookletModal"
                  @showStatusModal="showStatusModal"
                />
              </div>
            </div>
          </b-tab>
          <b-tab title="Charts" lazy>
            <ChartsComponent />
          </b-tab>
          <b-tab title="Lista">
            <TableComponent
              ref="tableComponent"
              :filters="filters"
              @showBookletModal="showBookletModal"
              @showStatusModal="showStatusModal"
            />
          </b-tab>

          <template #tabs-end>
            <b-nav-item
              v-if="currentTab !== 1"
              small
              href="#"
              role="presentation"
              @click.prevent="showFilterModal"
              style=""
            >
              <b-icon-filter scale="2" />
            </b-nav-item>
          </template>
        </b-tabs>

        <!-- Modal Filtros -->
        <b-modal
          v-model="isFilterModalVisible"
          title="Filtros"
          size="lg"
          no-close-on-esc
          no-close-on-backdrop
          hide-header-close
          centered
          @ok="applyFilters"
        >
          <b-form>
            <b-row>
              <!-- Filtro de Unidades (Facilities) -->
              <b-col md="6">
                <b-form-group label="Facilities">
                  <v-select
                    :options="unitOptions"
                    v-model="filters.unitFilter"
                    class="mb-2"
                    multiple
                    :reduce="(val) => val.value"
                  />
                </b-form-group>
              </b-col>

              <!-- Filtro de Estado (Status) -->
              <b-col md="6">
                <b-form-group label="Status">
                  <v-select
                    :options="statusOptions"
                    v-model="filters.statusFilter"
                    class="mb-2"
                    :reduce="(val) => val.value"
                  />
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <!-- Filtro de Fecha de Inicio (Start Date) -->
              <b-col md="6">
                <b-form-group label="Start Date">
                  <flat-pickr
                    class="form-control mb-2"
                    v-model="filters.startDate"
                    :config="{ enableTime: true, dateFormat: 'Y-m-d H:i' }"
                  />
                </b-form-group>
              </b-col>

              <!-- Filtro de Fecha de Fin (End Date) -->
              <b-col md="6">
                <b-form-group label="End Date">
                  <flat-pickr
                    class="form-control mb-2"
                    v-model="filters.endDate"
                    :config="{ enableTime: true, dateFormat: 'Y-m-d H:i' }"
                  />
                </b-form-group>
              </b-col>
            </b-row>

            <!-- Botón para limpiar selección -->
            <b-row>
              <b-col>
                <div class="text-center">
                  <b-button variant="danger" @click="clearFilters">
                    {{ $t("service_orders.delete_selection") }}
                  </b-button>
                </div>
              </b-col>
            </b-row>
          </b-form>
        </b-modal>

        <ShowMaintenanceFormModal
          :template-id="templateId"
          :service-order-id="serviceOrderId"
          @onSubmitFormBooklet="onSubmitFormBooklet"
          @onFormValidated="onFormValidated"
        />

        <!-- Modal Status(Ya no se ocupa) -->
        <b-modal
          v-model="isStatusModalVisible"
          title="Change Status"
          size="sm"
          no-close-on-esc
          no-close-on-backdrop
          hide-header-close
          centered
        >
          <b-form>
            <b-row>
              <span>
                {{ selectedServiceOrder.reference_number }}
              </span>
              <!-- status -->
              <b-col cols="12">
                <b-form-group label="Status">
                  <v-select
                    :options="statusOptions"
                    v-model="selectedServiceOrder.status_id"
                    class="mb-2"
                    :reduce="(val) => val.value"
                  />
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>
          <template #modal-footer>
            <div class="mr-auto">
              <button
                type="button"
                class="btn btn-danger text-capitalize"
                @click="closeStatusModal"
              >
                {{ $t("actions.cancel") }}
              </button>
            </div>
            <button
              type="button"
              class="btn btn-primary mr-2 text-capitalize"
              @click="changeStatuOrder"
            >
              {{ $t("actions.save_changes") }}
            </button>
          </template>
        </b-modal>
      </div>
    </div>
  </div>
</template>

<script>
import MapComponent from "@/views/maintenance_index/MapComponent.vue";
import TableComponent from "@/views/maintenance_index/TableComponent.vue";
import ChartsComponent from "@/views/maintenance_index/ChartsComponent.vue";
import {
  BCard,
  BContainer,
  BCardGroup,
  BCardText,
  BListGroup,
  BListGroupItem,
  BRow,
  BCol,
  BFormInput,
  BTable,
  BTab,
} from "bootstrap-vue";
import {
  ref,
  computed,
  watch,
  nextTick,
  onMounted,
  getCurrentInstance,
} from "@vue/composition-api";
import store from "@/store";
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import ShowMaintenanceFormModal from "@/components/ShowMaintenanceFormModal.vue";
import { EventBus } from "@/libs/event-bus";
import { getUserData } from "@/auth/utils";

export default {
  components: {
    BCard,
    BContainer,
    BCardGroup,
    BCardText,
    BListGroup,
    BListGroupItem,
    BRow,
    BCol,
    BFormInput,
    BTable,
    BTab,
    vSelect,
    flatPickr,
    MapComponent,
    TableComponent,
    ChartsComponent,
    ShowMaintenanceFormModal,
  },
  setup(props, { emit, parent }) {
    store.dispatch("unit/getAll");
    store.dispatch("maintenance/getAll");
    store.dispatch("service_orders_status/getAll");

    const vm = getCurrentInstance().proxy;

    const tableComponent = ref(null);
    const currentTab = ref(0);

    const templateId = ref(0);
    const serviceOrderId = ref(0);
    const selectedServiceOrder = ref({ status: [{ status: "pending" }] });
    const updateServiceOrderStatus = ref(1);
    const statusItems = computed(() => store.getters["service_orders_status/getItems"]);

    const isStatusModalVisible = ref(false);
    const isFilterModalVisible = ref(false);
    const unitOptions = computed(() => store.getters["unit/getSelectedItems"]);
    const maintenanceOptions = computed(
      () => store.getters["maintenance/getSelectedItems"]
    );
    const statusOptions = computed(
      () => store.getters["service_orders_status/getSelectedItems"]
    );

    const isCardMinimized = ref(false);

    const toast = useToast();

    const filters = ref({
      unitFilter: [],
      statusFilter: null,
      startDate: "",
      endDate: "",
      selectedDateFilter: null,
    });

    const dateOptions = ref([
      {
        text: parent.$i18n.t("service_orders.attention_date"),
        value: "attention_date",
      },
      {
        text: parent.$i18n.t("service_orders.status_change_date"),
        value: "status",
      },
      { text: parent.$i18n.t("date.created_at"), value: "created_at" },
    ]);

    const toggleCardMinimize = (data) => {
      isCardMinimized.value = !isCardMinimized.value;
    };

    const showStatusModal = (data) => {
      //console.log({ data });
      selectedServiceOrder.value = data;
      isStatusModalVisible.value = true;
    };

    const closeStatusModal = () => {
      isStatusModalVisible.value = false;
    };

    const showFilterModal = () => {
      isFilterModalVisible.value = true;
    };

    const clearFilters = () => {
      filters.value.unitFilter = [];
      filters.value.statusFilter = null;
      filters.value.startDate = null;
      filters.value.endDate = null;
      filters.value.selectedDateFilter = null;
    };

    const applyFilters = () => {
      //console.log("aplico filtros");
      EventBus.emit("apply-filters");
      if (tableComponent.value) {
        tableComponent.value.refreshTable();
      }
    };

    const showBookletModal = (detail) => {
      console.log({ detail });
      templateId.value = detail.template_id;
      serviceOrderId.value = detail.service_id;
      if (detail.status_id == 1) {
        //pendig
        let statusFind = statusItems.value.find((s) => s.status == "in_progress");
        let statusId = statusFind ? statusFind.id : null;
        if (statusId) {
          updateServiceOrderStatus.value = statusId;
          changeStatuOrder();
        }
      }
      vm.$root.$emit("bv::show::modal", "maintenance_form_modal");
    };

    const onSubmitFormBooklet = () => {
      vm.$root.$emit("bv::hide::modal", "maintenance_form_modal");
      let statusFind = statusItems.value.find((s) => s.status == "in_review");
      let statusId = statusFind ? statusFind.id : null;
      if (statusId) {
        updateServiceOrderStatus.value = statusId;
        changeStatuOrder();
      }
    };

    const onFormValidated = () => {
      vm.$root.$emit("bv::hide::modal", "maintenance_form_modal");
      let statusFind = statusItems.value.find((s) => s.status == "finished");
      let statusId = statusFind ? statusFind.id : null;
      if (statusId) {
        updateServiceOrderStatus.value = statusId;
        changeStatuOrder();
      }
    };

    const changeStatuOrder = () => {
      const req = {
        id: serviceOrderId.value,
        params: {
          id_status: updateServiceOrderStatus.value,
        },
      };

      store
        .dispatch("service_orders/editStatus", req)
        .then((response) => {
          if (response.success) {
            toast({
              component: ToastificationContent,
              props: {
                title: response.message,
                icon: "CheckIcon",
                variant: "success",
              },
            });
            closeStatusModal();
          } else {
            toast({
              component: ToastificationContent,
              props: {
                title: response.message,
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          }
        })
        .catch((response) => {
          toast({
            component: ToastificationContent,
            props: {
              title: response.response.data.message,
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        });
    };

    const updateComponents = () => {
      EventBus.emit("update-components");
      if (tableComponent.value) {
        tableComponent.value.refreshTable();
      }
    };

    const getGeoJson = () => {
      EventBus.emit("get-geojson");
    };

    const subscribeToEvents = () => {
      try {
        let userData = getUserData();
        if (
          !window.Echo.connector.channels["private-service-order-events-" + userData.id]
        ) {
          console.log("subscribeToEvents-Maintenance-Channel");
          console.log("userDataId" + userData.id)
          window.Echo.private("service-order-events-" + userData.id)
            .listen(".created", (data) => {
              updateComponents();
            })
            .listen(".updated", (data) => {
              updateComponents();
            });
        }
      } catch (error) {
        console.log("ERROR AL SUSCRIBIR CALL EVENTS" + error);
      }
    };

    setTimeout(() => {
      subscribeToEvents();
    }, 6000);

    return {
      isStatusModalVisible,
      showStatusModal,
      closeStatusModal,
      isFilterModalVisible,
      showFilterModal,
      applyFilters,
      clearFilters,
      filters,
      dateOptions,
      unitOptions,
      maintenanceOptions,
      statusOptions,
      statusItems,
      toast,
      templateId,
      serviceOrderId,
      selectedServiceOrder,
      showBookletModal,
      changeStatuOrder,
      tableComponent,
      updateServiceOrderStatus,
      onSubmitFormBooklet,
      onFormValidated,
      currentTab,
      subscribeToEvents,
      updateComponents,
      isCardMinimized,
      toggleCardMinimize,
      getGeoJson,
    };
  },
};
</script>

<style scoped>
.btn-filtro {
  position: fixed;
  top: calc(100px + 2rem);
  right: 14rem;
  z-index: 1030;
  width: 40px;
  height: 40px;
  line-height: 40px;
  text-align: center;
}

.states {
  position: fixed;
  bottom: calc(100px + 3rem);
  left: 3rem;
  z-index: 1030;
  background-color: white;
  padding: 10px;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.full-height {
  min-height: 100vh;
}

.tabs {
  min-width: 100%; /* Esto asegura que los tabs siempre ocupen el ancho total */
}

/*Mapa*/

.map-container {
  height: 100vh; /* 100% del viewport height */
}

.flex-container {
  display: flex;
  flex-direction: column;
}

.flex-container .map-container {
  flex: 1; /* Esto permitirá que el mapa se expanda para llenar el espacio disponible */
}

.states ul {
  padding-left: 0; /* Remueve el padding por defecto de las listas */
  display: grid;
}

.states li {
  display: flex;
  align-items: center;
  margin-bottom: 5px; /* Ajusta el margen según sea necesario */
  list-style: none; /* Remueve los estilos por defecto de lista */
}

.states li div {
  border-radius: 50%;
  height: 18px;
  width: 18px;
  margin-right: 5px; /* Ajusta el margen a tu preferencia */
}

.minimized-states-icon {
  position: fixed;
  bottom: calc(100px + 3rem);
  left: 3rem;
  z-index: 1030;
  background-color: white;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  cursor: pointer;
}

.minimize-button {
  background-color: transparent;
  border: none;
  position: absolute;
  top: -12px;
  right: -10px;
  cursor: pointer;
  padding: 0.5rem;
  line-height: 1;
  color: red;
}

.plus-button {
  background-color: transparent;
  border: none;
  cursor: pointer;
  line-height: 1;
}

.export-button {
  position: fixed;
  top: calc(100px + 10rem);
  right: 1rem;
  z-index: 1030;
  background-color: white;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  cursor: pointer;
}
/* .row.h-100 {
  height: 100%;
} */
</style>
